<template>
  <v-col cols="6">
    <v-menu v-model="menu" transition="scale-transition" max-height="300">
      <template v-slot:activator="{ on, attrs }">
        <input-text required
                    v-model="anoFabMod"
                    label="Ano Fab/Mod"
                    readonly
                    class="input-disabled-search"
                    :rules="anoModRules"
                    v-bind="attrs"
                    v-on="on"></input-text>
      </template>
      <v-list v-for="(item, i) in anos" :key="i" v-show="listaAno === i+1" class="pt-0">
        <v-list-item-group v-model="item.valor" @change="p => changeAno(p, i + 1)">
          <div>
            <p class="text-center primary white--text pa-3">
              {{ item.titulo }}
            </p>
          </div>
          <v-list-item class="text-center" v-for="ano in item.opcoes" :key="ano" :value="ano">
            <v-list-item-content>
              <v-list-item-title v-text="ano === 'Novo'? maxAno + ' 0km' : ano"></v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-menu>
  </v-col>
</template>

<script>
export default {
  props: {
    carencia: { type: Number, default: null },
    placa: null,
    value: null
  },
  data () {
    return {
      menu: false,
      tipoAno: {
        fab: { titulo: 'Ano de Fabricação', valor: null, opcoes: [] },
        mod: { titulo: 'Ano do Modelo', valor: null, opcoes: [] }
      },
      listaAno: 1,
      anoValorFipe: [],
      maxAno: 0,
      possuiModeloAnoAtual: true
    }
  },
  computed: {
    model: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    },
    anos: function () {
      return Object.keys(this.tipoAno).map(p => this.tipoAno[p])
    },
    anoFabMod: {
      get () {
        let val = ''
        if (this.model.AnoFab) {
          val = this.model.AnoFab + '/'
          if (this.model.AnoMod) { val += this.model.AnoMod + (this.model.ZeroKM ? ' 0km' : '') }
        }
        return val
      },
      set () { }
    }
  },
  methods: {
    change (value) {
      this.emit('change', value)
    },
    anoModRules () {
      return [!!this.model.AnoMod || 'Ano do modelo é obrigatório!']
    },
    openMenu () {
      const th = this
      setTimeout(function () {
        if (!th.menu) { th.menu = true } else { th.openMenu() }
      }, 100)
    },
    changeAno (val, i, isLoad) {
      const th = this
      th.listaAno = i === 1 ? 2 : 1

      if (val) {
        if (i === 1) {
          th.$set(th.model, 'AnoFab', val)

          th.tipoAno.mod.opcoes = []
          if (th.possuiModeloAnoAtual) { th.tipoAno.mod.opcoes.push(val) }

          if (th.anoValorFipe.find(p => parseInt(p.ano) === (val + 1))) {
            th.tipoAno.mod.opcoes.push(val + 1)
          }

          if (th.anoValorFipe.find(p => p.ano === 'Novo') && th.tipoAno.mod.opcoes.reduce((a, b) => Math.max(a, b)) === th.maxAno) {
            th.tipoAno.mod.opcoes.push('Novo')
          }

          th.tipoAno.mod.valor = null
          th.$set(th.model, 'AnoMod', null)
        } else {
          const ano = val === 'Novo' ? th.maxAno : val
          const zero = val === 'Novo'
          th.$set(th.model, 'AnoMod', ano)
          th.$set(th.model, 'ZeroKM', zero)
          th.changeZeroKM(zero)
          th.setValorFipe(val)
        }
      } else {
        if (i === 1) {
          th.$set(th.tipoAno.fab, 'valor', th.model.AnoFab)
        } else {
          th.$set(th.tipoAno.mod, 'valor', th.model.AnoMod === th.maxAno && th.model.ZeroKM ? 'Novo' : th.model.AnoMod)
        }
      }

      if (i === 1 && !isLoad) { th.openMenu() }
    },
    setValorFipe (val, mantemValorVeiculoAoAbrirEdicao) {
      const th = this
      let fipe = th.anoValorFipe.find(p => p.ano.toString() === val.toString())
      if (!fipe && th.model.AnoFab + 1 === val) { fipe = th.anoValorFipe.find(p => p.ano === 'Novo') }

      if (fipe) {
        th.$set(th.model, 'VlrFipe', fipe.valor)
        if (!mantemValorVeiculoAoAbrirEdicao) { th.$emit('change', fipe.valor) }
      }
    },
    changeZeroKM (val) {
      this.model.Placa = ''
      if (val === true) {
        this.$set(this.model, 'Placa', this.placa)
      }
      this.$emit('getTaxa')
    },
    loadData (openMenu, value, callbackError) {
      const th = this
      th.possuiModeloAnoAtual = true
      th.$api.Kraken.GetValoresPorMarcaModelo(th.model.TipoPlaca, th.model.Marca, value).then(function (response) {
        if (th.$api.UI.PostLoadData(response, true) && response[0]) {
          let data = response[0].valores
          const anoAtual = new Date().getFullYear()
          const anoBase = anoAtual - th.carencia
          if (th.carencia !== null) {
            data = data.filter(p => p.ano >= anoBase)
            if (data.length === 0) {
              callbackError(anoBase)
            }
          }
          if (data.length !== 0) {
            th.anoValorFipe = response[0].valores
            data = th.$api.UTIL.Array.OrderBy(data, 'ano', 'desc')
            data.forEach(p => { p.ano = parseInt(p.ano) })
            th.tipoAno.fab.opcoes = data.filter(p => p.ano <= anoAtual).map(p => p.ano)
            if (th.tipoAno.fab.opcoes.length === 0 && data.some(p => p.ano === anoAtual + 1)) {
              th.possuiModeloAnoAtual = false
              th.tipoAno.fab.opcoes = [anoAtual]
            }
            th.maxAno = data[0].ano
            if (openMenu) { th.menu = true } else if (th.model.AnoMod) {
              th.setValorFipe((th.model.AnoMod === th.maxAno && th.model.ZeroKM ? 'Novo' : th.model.AnoMod), true)
            }
          }
        }
      })
    },
    clear () {
      this.$set(this.tipoAno.fab, 'opcoes', [])
      this.$set(this.tipoAno.fab, 'valor', null)
      this.$set(this.tipoAno.mod, 'valor', null)
      this.$set(this, 'anoValorFipe', [])
    }
  }
}
</script>
